<template>
    <div>
        <title>券卡出库</title>
        <article class="cardArticle">
            <section class="cardCon">
                <main class="cardMain">
                  <CardModify :type="4" :batchcode="batchcode"></CardModify>
                </main>
            </section>
        </article>
    </div>
</template>
<script>
export default {
  name: "CardsOut",
  // ==================================== 组件====================================
  components: {
    CardModify: resolve =>require(["@/components/CardsFolder/CardModify.vue"], resolve), //验证券码
  },
  data() {
    return {
      batchcode:'',
    };
  },
  mounted() {
    if(this.$route.query.batchcode){
       this.batchcode = this.$route.query.batchcode;
    }
  },
};
</script>
<style scoped>
.cardCon {
  position: relative;
  padding: 20px 20px 85px 0;
  height: calc(100% - 169px);
}
.cardWrap {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/CardsFolder/CardsElectron/CardManage/ElectronOperate.vue